export const getHeatmapColors = (returnPct, heatmapScale) => {
  let bgColor, textColor, borderColor;

  if (returnPct > 0) {
    const ratio = Math.min(returnPct / heatmapScale.maxPositive, 1);

    if (ratio < 0.1) {
      const intensity = ratio / 0.1;
      bgColor = `rgb(${Math.floor(55 - intensity * 10)}, ${Math.floor(
        35 + intensity * 10
      )}, ${Math.floor(10 + intensity * 5)})`;
      textColor = "#d4b106";
      borderColor = "#ad8b00";
    } else if (ratio < 0.25) {
      const intensity = (ratio - 0.1) / 0.15;
      bgColor = `rgb(${Math.floor(45 - intensity * 15)}, ${Math.floor(
        45 + intensity * 5
      )}, ${Math.floor(15)})`;
      textColor = "#bae637";
      borderColor = "#95de64";
    } else if (ratio < 0.5) {
      const intensity = (ratio - 0.25) / 0.25;
      bgColor = `rgb(${Math.floor(30 - intensity * 10)}, ${Math.floor(
        50 + intensity * 10
      )}, ${Math.floor(15)})`;
      textColor = "#95de64";
      borderColor = "#73d13d";
    } else if (ratio < 0.75) {
      const intensity = (ratio - 0.5) / 0.25;
      bgColor = `rgb(${Math.floor(20 - intensity * 5)}, ${Math.floor(
        60 + intensity * 10
      )}, ${Math.floor(15 + intensity * 5)})`;
      textColor = "#73d13d";
      borderColor = "#52c41a";
    } else if (ratio < 0.9) {
      const intensity = (ratio - 0.75) / 0.15;
      bgColor = `rgb(${Math.floor(15 - intensity * 5)}, ${Math.floor(
        70 + intensity * 15
      )}, ${Math.floor(20 + intensity * 5)})`;
      textColor = "#52c41a";
      borderColor = "#389e0d";
    } else {
      const intensity = (ratio - 0.9) / 0.1;
      bgColor = `rgb(${Math.floor(10 - intensity * 5)}, ${Math.floor(
        85 + intensity * 20
      )}, ${Math.floor(25 + intensity * 15)})`;
      textColor = "#00ff41";
      borderColor = "#00ff41";
    }
  } else {
    const ratio = Math.min(
      Math.abs(returnPct) / Math.abs(heatmapScale.minNegative),
      1
    );

    if (ratio < 0.25) {
      const intensity = ratio / 0.25;
      bgColor = `rgb(${Math.floor(60 + intensity * 10)}, ${Math.floor(
        15 + intensity * 5
      )}, ${Math.floor(15 + intensity * 5)})`;
      textColor = "#ff7875";
      borderColor = "#ff4d4f";
    } else if (ratio < 0.5) {
      const intensity = (ratio - 0.25) / 0.25;
      bgColor = `rgb(${Math.floor(70 + intensity * 10)}, ${Math.floor(
        20 - intensity * 10
      )}, ${Math.floor(20 - intensity * 10)})`;
      textColor = "#ff4d4f";
      borderColor = "#ff4d4f";
    } else if (ratio < 0.75) {
      const intensity = (ratio - 0.5) / 0.25;
      bgColor = `rgb(${Math.floor(80 + intensity * 10)}, ${Math.floor(
        10 - intensity * 5
      )}, ${Math.floor(10 - intensity * 5)})`;
      textColor = "#ff4d4f";
      borderColor = "#cf1322";
    } else {
      const intensity = (ratio - 0.75) / 0.25;
      bgColor = `rgb(${Math.floor(90 + intensity * 10)}, ${Math.floor(
        5 - intensity * 2
      )}, ${Math.floor(5 - intensity * 2)})`;
      textColor = "#ff4d4f";
      borderColor = "#a8071a";
    }
  }

  return { bgColor, textColor, borderColor };
};
